import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { useAuth0Datar84ij8t1ru66 as useAuth0Data } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/external/auth0/react/Dsl.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instanced0ci4wsv0lrw as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_Logout() {
  _init_properties_Logout_kt__geijva();
  var tmp = KProperty0();
  return Logout$delegate.getValue_u7qj63_k$(null, getPropertyCallableRef('Logout', 0, tmp, _get_Logout_$ref_oga0b4(), null));
}
var Logout$delegate;
function Logout$delegate$lambda($this$nfc, it) {
  _init_properties_Logout_kt__geijva();
  var auth0Data = useAuth0Data();
  var tmp = window.location.origin;
  // Inline function 'org.w3c.dom.get' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.Auth0LogoutParams.Companion.invoke' call
  // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.com_zegreatrob_coupling_client_components_external_auth0_react_Auth0LogoutParams_Companion_7c4w0q_invoke_jkqnwo' call
  // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.Auth0LogoutStructure.Companion.invoke' call
  // Inline function 'com.zegreatrob.coupling.client.components.external.auth0.react.com_zegreatrob_coupling_client_components_external_auth0_react_Auth0LogoutStructure_Companion_c2iooh_invoke_jkqnwo' call
  var tmp$ret$4 = {logoutParams: {returnTo: tmp + window['basename']}};
  auth0Data.logout_1(tmp$ret$4);
  setDefaultKey($this$nfc, '@rdk/18_4');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = Logout$delegate$lambda$lambda;
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
function Logout$delegate$lambda$lambda($this$div) {
  _init_properties_Logout_kt__geijva();
  return Unit_instance;
}
function _get_Logout_$ref_oga0b4() {
  return constructCallableReference(() => get_Logout(), 0, 0, 293);
}
var properties_initialized_Logout_kt_aof8vo;
function _init_properties_Logout_kt__geijva() {
  if (!properties_initialized_Logout_kt_aof8vo) {
    properties_initialized_Logout_kt_aof8vo = true;
    Logout$delegate = nfc(Logout$delegate$lambda);
  }
}
//region block: exports
export {
  get_Logout as get_Logouta46xaulpbvl3,
};
//endregion

//# sourceMappingURL=Logout.mjs.map
